import * as PIXI from 'pixi.js'
import { Assets, Container, Sprite } from "pixi.js"
import { containers, gameAssets, resetTutorial } from "../gameUI"
import { scaleFactor, tweenFade, } from "../utility"
import { settings } from "../../settings"
import { betHistory, setLang } from '../networkService'
import { mainBgSound, playMainBg, playPopTabChange, playPopUpClose, sfxSound, stopAllExceptMainBgSound } from '../soundManager'
import { gameData } from '../data'
import { bigWin } from '../commendation'
import { setupTutorial } from './tutorial'

let isPopupOpen = false
export const setupSettings = () => {
    if(!gameAssets.settingsBase){
        gameAssets.settingsBase = new Sprite(Assets.get('settings'))
    } 
    if(!containers.settingsContainer) containers.settingsContainer = new Container()
    containers.popupContainer.addChild(containers.settingsContainer)
    containers.popupContainer.visible = false
    containers.popupContainer.alpha = 0
    containers.settingsContainer.visible = true
    gameAssets.settingsBase.anchor.set(0.5)
    containers.settingsContainer.addChild(gameAssets.settingsBase)
    
    const width = gameAssets.settingsBase.width
    const height = gameAssets.settingsBase.height
    gameAssets.settingsBase.resize = (w, h) => {
        const expandFactor = 0.85
        const scale = scaleFactor(gameAssets.gameScreen.width, width)
        gameAssets.settingsBase.x = w * 0.5
        gameAssets.settingsBase.y = h * 0.44
        gameAssets.settingsBase.width = width * scale * expandFactor
        gameAssets.settingsBase.height = height * scale * expandFactor
    }  

    

    const tutorialBtnGraphic = new PIXI.Graphics();
    containers.tutorialButtonContainer.addChild(tutorialBtnGraphic)
    tutorialBtnGraphic.beginFill(0x552155, 1);
    tutorialBtnGraphic.drawRect(0, -1150, 575, 150);
    tutorialBtnGraphic.x = -285
    tutorialBtnGraphic.y = -60
    tutorialBtnGraphic.endFill();
    tutorialBtnGraphic.alpha = 0.01
    tutorialBtnGraphic.interactive = true
    tutorialBtnGraphic.cursor = 'pointer'
    tutorialBtnGraphic.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            playPopTabChange(true)
            containers.settingsContainer.visible = false
            containers.tutorialContainer.visible = true
        }
        
    } )

    const betHistoryGraphic = new PIXI.Graphics();
    containers.tutorialButtonContainer.addChild(betHistoryGraphic);
    betHistoryGraphic.beginFill(0x000000, 1);
    betHistoryGraphic.drawRoundedRect(-730, -1150, 580, 140, 0); // last param is corner radius
    betHistoryGraphic.x = 1050;
    betHistoryGraphic.y = -65;
    betHistoryGraphic.endFill();
    betHistoryGraphic.alpha = 0.01;
    betHistoryGraphic.interactive = true
    betHistoryGraphic.cursor = 'pointer';
    betHistoryGraphic.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            playPopTabChange(true)
            containers.settingsContainer.visible = false
            containers.tutorialContainer.visible = false;
            containers.betHistoryContainer.visible = true;
            betHistory()
        }   
    } )
    

    gameAssets.settingsBase.addChild(containers.tutorialButtonContainer)

    if(!gameAssets.closeBtn) gameAssets.closeBtn = new Sprite(Assets.get('close_b_normal'))
    gameAssets.closeBtn.anchor.set(0.5)
    gameAssets.settingsBase.addChild(gameAssets.closeBtn)
    gameAssets.closeBtn.x = 770
    gameAssets.closeBtn.y = -860
    gameAssets.closeBtn.scale.set(1.5)
    gameAssets.closeBtn.interactive = true
    gameAssets.closeBtn.buttonMode = true
    gameAssets.closeBtn.cursor = 'pointer'
    gameAssets.closeBtn.on('pointerover', ()=> {gameAssets.closeBtn.texture = Assets.get('close_b_selected')})
    gameAssets.closeBtn.on('pointerout', ()=> {gameAssets.closeBtn.texture = Assets.get('close_b_normal')})
    gameAssets.closeBtn.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            hidePopup()
        }
    })

    const soundTexture = () => settings.sound ? Assets.get('sound_b_selected') : Assets.get('sound_b_normal')
    if(!gameAssets.soundBtn) 
        gameAssets.soundBtn = new Sprite(soundTexture())
    gameAssets.soundBtn.anchor.set(0.5)
    gameAssets.settingsBase.addChild(gameAssets.soundBtn)
    gameAssets.soundBtn.x = -590
    gameAssets.soundBtn.y = -500
    gameAssets.soundBtn.scale.set(1.8)
    gameAssets.soundBtn.interactive = true
    gameAssets.soundBtn.buttonMode = true
    gameAssets.soundBtn.on('pointerover', ()=> {gameAssets.soundBtn.cursor = 'pointer';})
    gameAssets.soundBtn.on('pointerout', () => {gameAssets.soundBtn.texture = soundTexture()})
    gameAssets.soundBtn.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

            if(!isPopupOpen) return
    
            settings.sound = !settings.sound
            sfxSound.value = settings.sound
            if(!settings.sound) stopAllExceptMainBgSound()
            gameAssets.soundBtn.texture = soundTexture()
        }

        // hidePopup()
        // setCommendationType(COMMENDATION.NORMAL)
        // normalWin(winningAmount())
    })

    const musicTexture = () => settings.music ? Assets.get('music_b_selected') : Assets.get('music_b_normal')
    if(!gameAssets.musicBtn) 
        gameAssets.musicBtn = new Sprite(musicTexture())
    gameAssets.musicBtn.anchor.set(0.5)
    gameAssets.settingsBase.addChild(gameAssets.musicBtn)
    gameAssets.musicBtn.x = -30
    gameAssets.musicBtn.y = -500
    gameAssets.musicBtn.scale.set(1.8)
    gameAssets.musicBtn.interactive = true
    gameAssets.musicBtn.buttonMode = true
    gameAssets.musicBtn.on('pointerover', ()=> {gameAssets.musicBtn.cursor = 'pointer';})
    gameAssets.musicBtn.on('pointerout', () => {gameAssets.musicBtn.texture = musicTexture()})
    gameAssets.musicBtn.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            if(!isPopupOpen) return
    
            settings.music = !settings.music
            mainBgSound.value = settings.music
            if(settings.music) playMainBg(true)
            else playMainBg(false) 
            gameAssets.musicBtn.texture = musicTexture()
        }
        
    })

    const vibrateTexture = () => settings.vibrate ? Assets.get('vibrate_b_normal') : Assets.get('vibrate_b_selected')
    if(!gameAssets.vibrateBtn) 
        gameAssets.vibrateBtn = new Sprite(vibrateTexture())
    gameAssets.vibrateBtn.anchor.set(0.5)
    gameAssets.settingsBase.addChild(gameAssets.vibrateBtn)
    gameAssets.vibrateBtn.x = 530
    gameAssets.vibrateBtn.y = -500
    gameAssets.vibrateBtn.scale.set(1.8)
    gameAssets.vibrateBtn.interactive = true
    gameAssets.vibrateBtn.buttonMode = true
    gameAssets.vibrateBtn.on('pointerover', ()=> {gameAssets.vibrateBtn.cursor = 'pointer';gameAssets.vibrateBtn.texture = Assets.get('vibrate_b_selected')})
    gameAssets.vibrateBtn.on('pointerout', () => {gameAssets.vibrateBtn.texture = vibrateTexture()})
    gameAssets.vibrateBtn.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            if(!isPopupOpen) return
    
            settings.vibrate = !settings.vibrate
            gameAssets.vibrateBtn.texture = vibrateTexture()
        }
        // hidePopup()
        // setCommendationType(COMMENDATION.MAJOR)
        // majorJackpot('1500')
    })


    
    const languageText = new PIXI.Sprite(PIXI.Assets.get('lang'))
      languageText.anchor.set(0.5);
      languageText.scale.set(2.5);
      languageText.x = 0;
      languageText.y = -30;
     
      gameAssets.settingsBase.addChild(languageText)
            const toggle1Container = new PIXI.Container();
            const toggle2Container = new PIXI.Container();
    
            gameAssets.langEnglishSelect = new PIXI.Sprite(PIXI.Assets.get('lang_english_select'))
            gameAssets.langEnglishNonSelect = new PIXI.Sprite(PIXI.Assets.get('lang_english_nonselect'))
    
             gameAssets.langTagalogSelect = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog_select'))
             gameAssets.langTagalogNonSelect = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog_nonselect'))
    
             gameAssets.currentActiveLanguage = gameAssets.langEnglishSelect
    
            toggle1Container.y = 200
            toggle1Container.x = -5
            toggle1Container.pivot.x = toggle1Container.width / 2
            toggle1Container.scale.set(2)
    
            gameAssets.langEnglishNonSelect.visible = false
            gameAssets.langEnglishSelect.visible = true
    
            gameAssets.langEnglishSelect.x = -gameAssets.langEnglishSelect.width / 2
            gameAssets.langEnglishNonSelect.x = -gameAssets.langEnglishNonSelect.width / 2
    
            toggle1Container.interactive = true;
            toggle1Container.buttonMode = true;
            toggle1Container.cursor = 'pointer'
    
            toggle1Container.addChild(gameAssets.langEnglishSelect)
            toggle1Container.addChild(gameAssets.langEnglishNonSelect)
    
            
    
            toggle2Container.y = toggle1Container.y + 300
            toggle2Container.x = -5
            toggle2Container.pivot.x = toggle2Container.width / 2
            toggle2Container.scale.set(2)
    
            gameAssets.langTagalogNonSelect.visible = true
            gameAssets.langTagalogSelect.visible = false
    
            gameAssets.langTagalogSelect.x = -gameAssets.langTagalogSelect.width / 2;
            gameAssets.langTagalogNonSelect.x = -gameAssets.langTagalogNonSelect.width / 2;
    
            toggle2Container.interactive = true
            toggle2Container.buttonMode = true
            toggle2Container.cursor = 'pointer'
    
            toggle2Container.addChild(gameAssets.langTagalogSelect)
            toggle2Container.addChild(gameAssets.langTagalogNonSelect)

            toggle1Container.on('pointerdown', (event) => {
                if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                    if (gameAssets.currentActiveLanguage === gameAssets.langEnglishSelect) return;
            
                    gameAssets.langEnglishNonSelect.visible = false;
                    gameAssets.langEnglishSelect.visible = true;
                    gameAssets.currentActiveLanguage = gameAssets.langEnglishSelect;
                    gameAssets.langTagalogNonSelect.visible = true;
                    gameAssets.langTagalogSelect.visible = false;
                    setLang('en')
                    setupTutorial('en')         
                    resetTutorial() 
                    setActiveLanguage('en')

                    
                }
            });
            
            toggle2Container.on('pointerdown', (event) => {
                if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                    if (gameAssets.currentActiveLanguage === gameAssets.langTagalogSelect) return;
            
                    gameAssets.langTagalogNonSelect.visible = false;
                    gameAssets.langTagalogSelect.visible = true;
                    gameAssets.currentActiveLanguage = gameAssets.langTagalogSelect;
                    gameAssets.langEnglishNonSelect.visible = true;
                    gameAssets.langEnglishSelect.visible = false;
            
                    setLang('tl')
                    setupTutorial('tl')         
                    resetTutorial() 
                    setActiveLanguage('tl')
                }
            });
    
            
            gameAssets.settingsBase.addChild(toggle1Container, toggle2Container)

             const fpsButton = new PIXI.Sprite(PIXI.Assets.get('fpsEnabled'));
             fpsButton.anchor.set(0.5);
             fpsButton.scale.set(0.49);
             fpsButton.x = 0
             fpsButton.y = 835
             fpsButton.interactive = true
             fpsButton.cursor = 'pointer'
             // gameAssets.settingsBase.addChild(fpsButton)

             const hover = new PIXI.Sprite(PIXI.Assets.get('fpsEnabled'));
             hover.anchor.set(0.5);  
             fpsButton.addChild(hover);
             hover.visible = false;

             fpsButton.on('pointerover', () => {
                hover.visible = true;
            });

            fpsButton.on('pointerout', () => {
                hover.visible = false;
            });

             const disable = new PIXI.Sprite(PIXI.Assets.get('fpsDisabled'));
             disable.anchor.set(0.5);
             fpsButton.addChild(disable);
             disable.visible = false;

            fpsButton.on('pointerdown', (event) => {
                if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                    if (disable.visible) {
                        disable.visible = false
                        //    globalVolumes(1);
                        hideMainBg()
    
                    }
                    else {
                        disable.visible = true
                        //   globalVolumes(0);
                        showMainBg()
                    }
                }
            });
            const checkboxYStart = 780;

            const majorCheckbox = createCheckbox("Mega", (val) => {
                console.log("Major:", val);
            });
            majorCheckbox.x = -700;
            majorCheckbox.y = checkboxYStart;
            majorCheckbox.visible = false;
            
            const minorCheckbox = createCheckbox("Big", (val) => {
                console.log("Minor:", val);
            });
            minorCheckbox.x = 400;
            minorCheckbox.y = 780;
            minorCheckbox.visible = false;
            
            const grandCheckbox = createCheckbox("Ultra", (val) => {
                console.log("Grand:", val);
            });
            grandCheckbox.x = -130;
            grandCheckbox.y = 910;
            grandCheckbox.visible = false;
            
            const winGraphic = new PIXI.Graphics();
            winGraphic.lineStyle(20, 0xffa500); // 8px orange border
            winGraphic.beginFill(0xffff00);    // Yellow fill
            winGraphic.drawRoundedRect(-400, 600, 800, 200, 30);
            winGraphic.endFill();
            winGraphic.interactive = true;
            winGraphic.buttonMode = true;
            winGraphic.cursor = 'pointer';
            winGraphic.y = 180;
            
            const winLabel = new PIXI.Text("Show Win..", {
                fontSize: 90,
                fill: 0x000000,
                fontWeight: 'bold',
            });
            winLabel.anchor.set(0.5);
            winLabel.x = 0;
            winLabel.y = 700;
            winGraphic.addChild(winLabel);
            
            winGraphic.on('pointertap', () => {
                winGraphic.visible = false;
                gameData.showWin = true;    
                majorCheckbox.visible = true;
                minorCheckbox.visible = true;
                grandCheckbox.visible = true;
            });
            
            // Add everything to the stage
            // gameAssets.settingsBase.addChild(
            //     winGraphic,
            //     majorCheckbox,
            //     minorCheckbox,
            //     grandCheckbox
            // );
    
            
    
    const buildText = new PIXI.Text('Version Number ' + gameData.gameVersion, {
      fill: '#000000',
      fontSize: 53,
      fontFamily: 'Arial',
      align: 'center',
      fontWeight: 'bold' 
    })
    buildText.anchor.set(0.5)
    gameAssets.settingsBase.addChild(buildText)
    buildText.x = 0
    buildText.y = 1115
    buildText.scale.set(1.5)
}

const checkboxGroup = [];

const createCheckbox = (labelText, value, onChange) => {
    const container = new PIXI.Container();
    const boxSize = 80;

    const box = new PIXI.Graphics();
    box.lineStyle(3, 0x000000);
    box.beginFill(0xffffff);
    box.drawRect(0, 0, boxSize, boxSize);
    box.endFill();
    container.addChild(box);

    const checkmark = new PIXI.Graphics();
    checkmark.lineStyle(20, 0x00cc00, 1);
    checkmark.moveTo(18, 45);
    checkmark.lineTo(35, 60);
    checkmark.lineTo(62, 20);
    checkmark.visible = false;
    container.addChild(checkmark);

    const label = new PIXI.Text(labelText, {
        fontSize: 104,
        fill: 0x000000,
        fontWeight: 'bold'
    });
    label.x = boxSize + 15;
    label.y = -10;
    container.addChild(label);

    container.labelText = labelText;

    let checked = false;

    container.interactive = true;
    container.buttonMode = true;
    container.cursor = 'pointer';

    container.on('pointertap', () => {
        if (checked) {
            container.setChecked(false);
            gameData.showWin = false;
            gameData.winType = null;
            if (onChange) onChange(false, value);
        } else {
            checkboxGroup.forEach(cb => cb.setChecked(false));
            gameData.showWin = true;

            container.setChecked(true);
            if(container.labelText == "Mega"){
                gameData.winType = "megaWin";
            } else if(container.labelText == 'Big'){
                gameData.winType = 'bigWin'
            } else if(container.labelText == 'Ultra') {
                gameData.winType = 'ultraWin'
            }
            if (onChange) onChange(true, value);
        }
    });

    container.setChecked = (val) => {
        checked = val;
        checkmark.visible = val;
    };

    container.isChecked = () => checked;

    checkboxGroup.push(container);

    return container;
};

const hideMainBg = () => {
    document.body.removeChild(gameData.stats.dom);
}

const showMainBg = () => {
    document.body.appendChild(gameData.stats.dom); 
}
export const hidePopup = () => {
    setIsPopupOpen(false)
    playPopUpClose(true)
    
    gameData.isPopupOpen = false;
    tweenFade(gameAssets.dimmer, false, 0.3)
    tweenFade(containers.popupContainer, false, 0.3, ()=>{
        gameAssets.dimmer.visible = false;
        containers.popupContainer.visible = false;
    })
    containers.popupContainer.interactiveChildren = false
    gameAssets.footer.visible = true;
}

export const setIsPopupOpen = (isOpen) => {
    isPopupOpen = isOpen
}

export const getIsPopupOpen = () => isPopupOpen

export const setActiveLanguage = (lang) => {    
    if (lang === "en") {
        gameAssets.langEnglishNonSelect.visible = false;
        gameAssets.langEnglishSelect.visible = true;
        gameAssets.langTagalogNonSelect.visible = true;
        gameAssets.langTagalogSelect.visible = false;
        gameAssets.currentActiveLanguage = gameAssets.langEnglishSelect;

    } else if (lang === "tl") {
        gameAssets.langEnglishNonSelect.visible = true;
        gameAssets.langEnglishSelect.visible = false;
        gameAssets.langTagalogNonSelect.visible = false;
        gameAssets.langTagalogSelect.visible = true;
        gameAssets.currentActiveLanguage = gameAssets.langTagalogSelect;
    }
};